var bordercolor = getComputedStyle(document.body).getPropertyValue('--bordercolor');
var bodycolor = getComputedStyle(document.body).getPropertyValue('--bodycolor');
import bfunctions from '@/demo-data/Chart/BasicFunction.js';
window.chartColors = {
    red: 'rgb(30, 61, 115)',
    orange: 'rgb(23, 162, 184)',
    yellow: 'rgb(30, 224, 172)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};
export default [
    {
        verticalbarchart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [{
                label: 'Dataset 1',
                backgroundColor: 'rgba(30, 61, 115,0.5)',
                borderColor: window.chartColors.red,
                borderWidth: 1,
                data: [35, 60, -10, -30, -25, -90, 70]

            }, {
                label: 'Dataset 2',
                backgroundColor: 'rgba(54, 162, 235,0.5)',
                borderColor: window.chartColors.blue,
                borderWidth: 1,
                data: [-70, -55, 90, -90, 25, 70, 40]
            }]
            },
            options: {
                layout: {
                    padding: {
                        left: 10,
                        right: 10,
                        top: 10,
                        bottom: 10
                    }
                },
                responsive: true,
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                scales: {
                    xAxes: [{
                            display: true,
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
        
                            },
                        }],
                    yAxes: [{
                            display: true,
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
        
                            }
                        }]
                }

            }
        },
        horizontalbarchart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [{
                label: 'Dataset 1',
                backgroundColor: 'rgba(30, 61, 115,0.5)',
                borderColor: window.chartColors.red,
                borderWidth: 1,
                data: [35, 60, -10, -30, -25, -90, 70]

            }, {
                label: 'Dataset 2',
                backgroundColor: 'rgba(54, 162, 235,0.5)',
                borderColor: window.chartColors.blue,
                borderWidth: 1,
                data: [-70, -55, 90, -90, 25, 70, 40]
            }]
            },
            options: {
                layout: {
                    padding: {
                        left: 10,
                        right: 10,
                        top: 10,
                        bottom: 10
                    }
                },
                responsive: true,
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                scales: {
                    xAxes: [{
                            display: true,
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
        
                            },
                        }],
                    yAxes: [{
                            display: true,
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
        
                            }
                        }]
                }

            }
        },
        multiaxisbarchart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [{
                label: 'Dataset 1',
                backgroundColor: [
                    window.chartColors.red,
                    window.chartColors.orange,
                    window.chartColors.yellow,
                    window.chartColors.green,
                    window.chartColors.blue,
                    window.chartColors.purple,
                    window.chartColors.red
                ],
                yAxisID: 'y-axis-1',
                data: [35, 60, -10, -30, -25, -90, 70]
            }, {
                label: 'Dataset 2',
                backgroundColor: window.chartColors.grey,
                yAxisID: 'y-axis-2',
                data: [-70, -55, 90, -90, 25, 70, 40]
            }]
            },
            options: {
                layout: {
                    padding: {
                        left: 10,
                        right: 10,
                        top: 10,
                        bottom: 10
                    }
                },
                responsive: true,
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                scales: {
                    xAxes: [{
                            display: true,
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            },
                        }],
                    yAxes: [{
                            type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                            display: true,
                            position: 'right',
                            id: 'y-axis-2',
                            gridLines: {
                                drawOnChartArea: false,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            }
                        }, {
                            display: true,
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            }
                        }]
                }
            }
        },
        stackedbarchart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [{
                    label: 'Dataset 1',
                    backgroundColor: 'rgba(30, 61, 115,0.5)',
                    borderColor: window.chartColors.red,
                    borderWidth: 1,
                    data: [35, 60, -10, -30, -25, -90, 70]
    
                }, {
                    label: 'Dataset 2',
                    backgroundColor: 'rgba(54, 162, 235,0.5)',
                    borderColor: window.chartColors.blue,
                    borderWidth: 1,
                    data: [-70, -55, 90, -90, 25, 70, 40]
                }]
            },
            options: {
                layout: {
                    padding: {
                        left: 10,
                        right: 10,
                        top: 10,
                        bottom: 10
                    }
                },
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                responsive: true,
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                scales: {
                    xAxes: [{
                            stacked: true,
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            }
                        }],
                    yAxes: [{
                            stacked: true,
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            }
                        }]
                }
            }
        },
        basiclinechart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [{
                        label: 'My First dataset',
                        backgroundColor: window.chartColors.red,
                        borderColor: window.chartColors.red,
                        data: [35, 60, -10, -30, -25, -90, 70],
                        fill: false,
                    }, {
                        label: 'My Second dataset',
                        fill: false,
                        backgroundColor: window.chartColors.blue,
                        borderColor: window.chartColors.blue,
                        data: [-70, -55, 90, -90, 25, 70, 40]
                    }]
            },
            options: {
                layout: {
                    padding: {
                        left: 0,
                        right: 20,
                        top: 10,
                        bottom:0
                    }
                },
                responsive: true,
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                },
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true
                            },
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
    
                            }
                        }],
                    yAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true
                            },
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
    
                            }
                        }]
                }
            }
        },
        multilinechart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [{
                        label: 'My First dataset',
                        backgroundColor: window.chartColors.red,
                        borderColor: window.chartColors.red,
                        data: [35, 60, -10, -30, -25, -90, 70],
                        fill: false,
                    }, {
                        label: 'My Second dataset',
                        fill: false,
                        backgroundColor: window.chartColors.blue,
                        borderColor: window.chartColors.blue,
                        data: [-70, -55, 90, -90, 25, 70, 40]
                    }]
            },
            options: {
                layout: {
                    padding: {
                        left: 20,
                        right: 20,
                        top: 10,
                        bottom:10
                    }
                },
                responsive: true,
                hoverMode: 'index',
                stacked: false,
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },

                scales: {
                    xAxes: [{
                            display: true,
                            // grid line settings
                            gridLines: {

                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            }
                        }],
                    yAxes: [{
                            type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                            display: true,
                            position: 'left',
                            id: 'y-axis-1',
                            // grid line settings
                            gridLines: {
                                drawOnChartArea: false, // only want the grid lines for one axis to show up
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            }
                        }, {
                            type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                            display: true,
                            position: 'right',
                            id: 'y-axis-2',

                            // grid line settings
                            gridLines: {

                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            }
                        }],
                }
            }
        },
        steppedlinechart:
        {
            
            data: {
                labels: ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6'],
            datasets: [{
                    steppedLine: true,
                    data: [35, 60, -10, -30, -25, -90, 70],
                    borderColor: '#1e3d73',
                    fill: false,
                }]
            },
            options: {
                layout: {
                    padding: {
                        left: -10,
                        right: 20,
                        top: 10,
                        bottom:0
                    }
                },
                responsive: true,
            legend: {
                position: 'top',
                labels: {
                    fontColor: bodycolor
                }
            },
            scales: {
                xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true
                        },
                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,

                        }
                    }],
                yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true
                        },
                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,

                        }
                    }]
            }
            }
        },
        pointsizelinechart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [{
                        label: 'dataset - big points',
                        data: [-70, -55, 90, -90, 25, 70, 40],
                        backgroundColor: window.chartColors.red,
                        borderColor: window.chartColors.red,
                        fill: false,
                        borderDash: [5, 5],
                        pointRadius: 15,
                        pointHoverRadius: 10,
                    }, {
                        label: 'dataset - individual point sizes',
                        data: [-70, -55, 90, -90, 25, 70, 40],
                        backgroundColor: window.chartColors.blue,
                        borderColor: window.chartColors.blue,
                        fill: false,
                        borderDash: [5, 5],
                        pointRadius: [2, 4, 6, 18, 0, 12, 20],
                    }, {
                        label: 'dataset - large pointHoverRadius',
                        data: [35, 60, -10, -30, -25, -90, 70],
                        backgroundColor: window.chartColors.green,
                        borderColor: window.chartColors.green,
                        fill: false,
                        pointHoverRadius: 30,
                    }, {
                        label: 'dataset - large pointHitRadius',
                        data: [25, 40, -30, -50, -45, -80, 40],
                        backgroundColor: window.chartColors.yellow,
                        borderColor: window.chartColors.yellow,
                        fill: false,
                        pointHitRadius: 20,
                    }]
            },
            options: {
                layout: {
                    padding: {
                        left: -10,
                        right: 20,
                        top: 10,
                        bottom:0
                    }
                },
                responsive: true,
            legend: {
                position: 'bottom',
            },
            hover: {
                mode: 'index'
            },
            scales: {
                xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Month'
                        }
                    }],
                yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        }
                    }]
            },
            title: {
                display: true,
                text: ''
            }
            }
        },
        boundariesareachart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [{
                        backgroundColor: 'rgba(23, 162, 184,0.2)',
                        borderColor: window.chartColors.red,
                        data: [6.06, 82.2, -22.11, 21.53, -21.47, 73.61, -53.75, -60.32],
                        label: 'Dataset',
                        fill: 'start'
                    }]
            },
            options: {
                layout: {
                    padding: {
                        left: 10,
                        right: 20,
                        top: 10,
                        bottom:0
                    }
                },
                maintainAspectRatio: false,
            spanGaps: false,
            elements: {
                line: {
                    tension: 0.000001
                }
            },
            plugins: {
                filler: {
                    propagate: false
                }
            },
            legend: {
                position: 'top',
                labels: {
                    fontColor: bodycolor
                }
            },

            scales: {
                x: {
                    ticks: {
                        autoSkip: false,
                        maxRotation: 0
                    }
                },
                xAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,

                        },
                    }],
                yAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,

                        }
                    }]

            }
            }
        },
        datasetsareachart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August'],
            datasets: [{
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    borderColor: window.chartColors.red,
                    data: [73.15, 77.54, 53.72, 55.76, 62.18, 62.62, 64.47, 79.6],
                    hidden: true,
                    label: 'D0'
                }, {
                    backgroundColor: 'rgba(255, 159, 64, 0.5)',
                    borderColor: window.chartColors.orange,
                    data: [30.96, 59.3, 29.79, 38.75, 60.23, 52.77, 45.98, 27.28],
                    label: 'D1',
                    fill: '-1'
                }, {
                    backgroundColor: 'rgba(255, 205, 86, 0.5)',
                    borderColor: window.chartColors.yellow,
                    data: [48.52, 72.66, 40.44, 37.05, 78.78, 59.71, 38.36, 24.35],
                    hidden: true,
                    label: 'D2',
                    fill: 1
                }, {
                    backgroundColor: 'rgba(75, 192, 192, 0.5)',
                    borderColor: window.chartColors.green,
                    data: [45.09, 72.44, 49.36, 76.58, 39.3, 53.81, 54.19, 78.94],
                    label: 'D3',
                    fill: '-1'
                }, {
                    backgroundColor: 'rgba(54, 162, 235, 0.5)',
                    borderColor: window.chartColors.blue,
                    data: [57.71, 57.9, 31.36, 21.06, 47.73, 36.56, 23.85, 43.66],
                    label: 'D4',
                    fill: '-1'
                }, {
                    backgroundColor: 'rgba(201, 203, 207, 0.5)',
                    borderColor: window.chartColors.grey,
                    data: [54.53, 26.08, 65.71, 45.28, 47.76, 73.87, 28.81, 48.88],
                    label: 'D5',
                    fill: '+2'
                }, {
                    backgroundColor: 'rgba(153, 102, 255, 0.5)',
                    borderColor: window.chartColors.purple,
                    data: [28.14, 25.12, 49.44, 68.52, 54.2, 69.45, 35.01, 76.07],
                    label: 'D6',
                    fill: false
                }, {
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    borderColor: window.chartColors.red,
                    data: [68.91, 67.62, 50.71, 67.81, 66.33, 58.13, 26.15, 51.16],
                    label: 'D7',
                    fill: 8
                }, {
                    backgroundColor: 'rgba(255, 159, 64, 0.5)',
                    borderColor: window.chartColors.orange,
                    data: [58.32, 23.94, 42.09, 71.3, 21.18, 59.14, 57.05, 37.85],
                    hidden: true,
                    label: 'D8',
                    fill: 'end'
                }]
            },
            options: {
                layout: {
                    padding: {
                        left: 10,
                        right: 20,
                        top: 10,
                        bottom:0
                    }
                },
                maintainAspectRatio: false,
            spanGaps: false,
            elements: {
                line: {
                    tension: 0.000001
                }
            },
            legend: {
                position: 'top',
                labels: {
                    fontColor: bodycolor
                }
            },
            scales: {
                stacked: true,
                xAxes: [{
                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,

                        },
                    }],
                yAxes: [{

                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,

                        }
                    }]
            },
            plugins: {
                filler: {
                    propagate: false
                },
                'samples-filler-analyser': {
                    target: 'chart-analyser'
                }
            }
            }
        },
        stackedareachart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [{
                        label: 'My First dataset',
                        borderColor: window.chartColors.red,
                        backgroundColor: window.chartColors.red,
                        data: [10, 20, -59, -30, -84, -16, 79],
                    }, {
                        label: 'My Second dataset',
                        borderColor: window.chartColors.blue,
                        backgroundColor: window.chartColors.blue,
                        data: [57, 99, 22, -75, -31, 80, 4],
                    }, {
                        label: 'My Third dataset',
                        borderColor: window.chartColors.green,
                        backgroundColor: window.chartColors.green,
                        data: [77, -62, -23, -93, 79, -73, -58],
                    }, {
                        label: 'My Third dataset',
                        borderColor: window.chartColors.yellow,
                        backgroundColor: window.chartColors.yellow,
                        data: [-13, -62, 66, -57, 92, -39, 33],
                    }]
            },
            options: {
               
                layout: {
                    padding: {
                        left: 10,
                        right: 20,
                        top: 10,
                        bottom:0
                    }
                },
                responsive: true,

                tooltips: {
                    mode: 'index',
                },
                hover: {
                    mode: 'index'
                },
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                scales: {
                    xAxes: [{
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
    
                            },
                        }],
                    yAxes: [{
    
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
    
                            }
                        }]
                }
            }
        },
        radarareachart:
        {
            
            data: {
                labels: ["January", "February", "March", "April", "May", "June", "July", "August"],
        datasets: [{
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
                borderColor: window.chartColors.red,
                data: [15.09, 15.67, 12.5, 12.77, 13.62, 13.68, 13.93, 15.95],
                label: 'D0'
            }, {
                backgroundColor: 'rgba(255, 159, 64, 0.5)',
                borderColor: window.chartColors.orange,
                data: [24.55, 28.91, 21.81, 23.27, 26.98, 26.05, 25.39, 24.92],
                hidden: true,
                label: 'D1',
                fill: '-1'
            }, {
                backgroundColor: 'rgba(255, 205, 86, 0.5)',
                borderColor: window.chartColors.yellow,
                data: [36.35, 43.93, 32.54, 33.54, 42.82, 39.34, 35.84, 33.5],
                label: 'D2',
                fill: 1
            }, {
                backgroundColor: 'rgba(75, 192, 192, 0.5)',
                borderColor: window.chartColors.green,
                data: [47.7, 58.92, 44.45, 49.08, 53.39, 51.85, 48.4, 49.36],
                label: 'D3',
                fill: false
            }, {
                backgroundColor: 'rgba(54, 162, 235, 0.5)',
                borderColor: window.chartColors.blue,
                data: [60.73, 71.97, 53.96, 57.22, 65.09, 62.06, 56.91, 60.52],
                label: 'D4',
                fill: '-1'
            }, {
                backgroundColor: 'rgba(153, 102, 255, 0.5)',
                borderColor: window.chartColors.purple,
                data: [73.33, 80.78, 68.05, 68.59, 76.79, 77.24, 66.08, 72.37],
                label: 'D5',
                fill: '-1'
            }]
            },
            options: {
                layout: {
                    padding: {
                        left: 10,
                        right: 20,
                        top: 10,
                        bottom:0
                    }
                },
                maintainAspectRatio: true,
        spanGaps: false,
        legend: {
            position: 'top',
            labels: {
                fontColor: bodycolor
            }
        },
        elements: {
            line: {
                tension: 0.000001
            }
        },
        plugins: {
            filler: {
                propagate: false
            },
            'samples-filler-analyser': {
                target: 'chart-analyser'
            }
        },
        scale: {
            angleLines: {
                color: bordercolor
            },

            gridLines: {
                display: true,
                color: bordercolor,
                zeroLineColor: bordercolor
            },
            pointLabels: {
                // callback: function(value, index, values) {
                //     return '$' + value;
                // }
                fontColor: bodycolor,
            },
        }
            }
        },
        scatterchart:
        {
            
            data: {
               datasets: [{
                    label: 'My First dataset',
                    borderColor: window.chartColors.red,
                    backgroundColor: window.chartColors.red,
                    data: [{x: -63, y: 69}, {x: -79, y: -24}, {x: 1, y: 22}, {x: 32, y: 44}, {x: 60, y: -12}, {x: 81, y: -79}, {x: -74, y: -5}]
                }, {
                    label: 'My Second dataset',
                    borderColor: window.chartColors.blue,
                    backgroundColor: window.chartColors.blue,
                    data: [{x: -43, y: 49}, {x: -59, y: -64}, {x: 21, y: 42}, {x: 52, y: 64}, {x: 20, y: -32}, {x: 51, y: -59}, {x: -54, y: -10}]
                }]
            },
            options: {
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                scales: {
                    xAxes: [{
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            },
                        }],
                    yAxes: [{

                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,

                            }
                        }]
                }
            }
        },
        otherdoughnutchart:
        {
            
            data: {
                datasets: [{
                    data: [3, 28, 67, 6, 88],
                    backgroundColor: [
                        window.chartColors.red,
                        window.chartColors.orange,
                        window.chartColors.yellow,
                        window.chartColors.green,
                        window.chartColors.blue,
                    ],
                    label: 'Dataset 1'
                }],
            labels: [
                'Red',
                'Orange',
                'Yellow',
                'Green',
                'Blue'
            ]
            },
            options: {
                responsive: true,
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            }
        },
        otherpiechart:
        {
            
            data: {
                datasets: [{
                    data: [3, 28, 67, 6, 88],
                    backgroundColor: [
                        window.chartColors.red,
                        window.chartColors.orange,
                        window.chartColors.yellow,
                        window.chartColors.green,
                        window.chartColors.blue,
                    ],
                    label: 'Dataset 1'
                }],
            labels: [
                'Red',
                'Orange',
                'Yellow',
                'Green',
                'Blue'
            ]
            },
            options: {
                responsive: true,
                legend: {
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            }
        },
        otherpolarchart:
        {
            
            data: {
                datasets: [{
                    data: [ bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),],
                    backgroundColor: [
                        window.chartColors.red,
                        window.chartColors.orange,
                        window.chartColors.yellow,
                        window.chartColors.green,
                        window.chartColors.blue,
                    ],
                    label: 'Dataset 1'
                }],
            labels: [
                'Red',
                'Orange',
                'Yellow',
                'Green',
                'Blue'
            ]
            },
            options: { responsive: true,
                legend: {
                    position: 'right',
                    labels: {
                        fontColor: bodycolor
                    }
                },
    
                scale: {
                    ticks: {
                        beginAtZero: true
                    },
                    reverse: false,
    
                    angleLines: {
                        color: bordercolor
                    },
    
                    gridLines: {
                        display: true,
                        color: bordercolor,
                        zeroLineColor: bordercolor
                    }
    
                },
                animation: {
                    animateRotate: false,
                    animateScale: true
                }
            }
        },
        linearstepsizechart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [{
                    label: 'My First dataset',
                    backgroundColor: window.chartColors.red,
                    borderColor: window.chartColors.red,
                    data: [
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor()
                    ],
                    fill: false,
                }, {
                    label: 'My Second dataset',
                    fill: false,
                    backgroundColor: window.chartColors.blue,
                    borderColor: window.chartColors.blue,
                    data: [
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor(),
                        bfunctions.randomScalingFactor()
                    ],
                }]
            },
            options: {
                
            responsive: true,
            legend: {
                position: 'top',
                labels: {
                    fontColor: bodycolor
                }
            },
            tooltips: {
                mode: 'index',
                intersect: false,
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            scales: {
                xAxes: [{
                        display: true,

                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,

                        }

                    }],
                yAxes: [{
                        display: true,

                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,
                            min: 0,
                            max: 100,
                            // forces step size to be 5 units
                            stepSize: 5
                        }
                    }]
            }
            }
        },
        linearminmaxchart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [{
                    label: 'My First dataset',
                    backgroundColor: window.chartColors.red,
                    borderColor: window.chartColors.red,
                    data: [10, 30, 50, 20, 25, 44, -10],
                    fill: false,
                }, {
                    label: 'My Second dataset',
                    fill: false,
                    backgroundColor: window.chartColors.blue,
                    borderColor: window.chartColors.blue,
                    data: [100, 33, 22, 19, 11, 49, 30],
                }]
            },
            options: {
                
            responsive: true,
            legend: {
                position: 'top',
                labels: {
                    fontColor: bodycolor
                }
            },
            tooltips: {
                mode: 'index',
                intersect: false,
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            scales: {
                xAxes: [{
                        display: true,

                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,

                        }

                    }],
                yAxes: [{
                        display: true,

                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,
                            min: 10,
                            max: 50
                        }
                    }]
            }
            }
        },
        linearminmaxsuggchart:
        {
            
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [{
                    label: 'My First dataset',
                    backgroundColor: window.chartColors.red,
                    borderColor: window.chartColors.red,
                    data: [10, 30, 50, 20, 25, 44, -10],
                    fill: false,
                }, {
                    label: 'My Second dataset',
                    fill: false,
                    backgroundColor: window.chartColors.blue,
                    borderColor: window.chartColors.blue,
                    data: [100, 33, 22, 19, 11, 49, 30],
                }]
            },
            options: {
                
            responsive: true,
            legend: {
                position: 'top',
                labels: {
                    fontColor: bodycolor
                }
            },
            tooltips: {
                mode: 'index',
                intersect: false,
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            scales: {
                xAxes: [{
                        display: true,

                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,

                        }

                    }],
                yAxes: [{
                        display: true,

                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,
                            suggestedMin: 10,

                            // the data maximum used for determining the ticks is Math.max(dataMax, suggestedMax)
                            suggestedMax: 50
                        }
                    }]
            }
            }
        },
    },
    
]
